import 'angular:locale/data:fr';
import 'zone.js';(globalThis.$localize ??= {}).locale = "fr";
